import {useState, useEffect} from 'react';
import {Modal} from '../index';
import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../../selectors/modals/facebook_share';
import {FacebookShare} from '../../../../reducers/modals/actions';
import {closeModal, updateModal} from '../../../../reducers/modules/actions';
import {navigate} from '../../../../utils/navigation'; 
import {CopyToClipboard} from 'react-copy-to-clipboard';
import {toast} from 'react-toastify';
 


export default ({modal, data}) => {
    const [button, setButton] = useState(true),
          {post, invite_url} = useSelector(Selector),
          dispatch = useDispatch();

    useEffect(() => {
        window.availableFBPostTimeout = setTimeout(() => {
            setButton(false);
        }, 3e3);

        return () => {
            clearTimeout(window.availableFBPostTimeout);
        }
    }, []);

    return (
        <>
            <div className="creative-header" style={{
                background: `url(${window.location.origin}/source/modules/modals/facebook-post/share.png)`,
                backgroundSize: 'cover'
            }}>
                <div className="close dark" onClick={e => dispatch(closeModal())}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M6 18L18 6" stroke="#161C2D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M18 18L6 6" stroke="#161C2D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            </div>

            <div className="modal-text" style={{marginTop: '-30px'}}>
                <div className="title">Share the Post</div>
                <div className="description" style={{textAlign: "center", width: "80%"}}>Share our Facebook post and add your invite link to the post.<br/><u>Make sure the post is public.</u></div>
            </div>

            <div className="modal-copy-block">
                <div className="label">Your invite link</div>
                <CopyToClipboard text={`Get free $5 and a +50% first deposit bonus on my referral link ${invite_url}`} onCopy={e => {
                    toast.dismiss();
                    toast.info('Copied to clipboard!');
                }}>
                    <div className="input">
                        Get free $5 and a +50% first deposit bonus on my referral link {invite_url}

                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M10.6668 8.59992V11.3999C10.6668 13.7333 9.7335 14.6666 7.40016 14.6666H4.60016C2.26683 14.6666 1.3335 13.7333 1.3335 11.3999V8.59992C1.3335 6.26658 2.26683 5.33325 4.60016 5.33325H7.40016C9.7335 5.33325 10.6668 6.26658 10.6668 8.59992Z" stroke="#6F778D" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M14.6668 4.59992V7.39992C14.6668 9.73325 13.7335 10.6666 11.4002 10.6666H10.6668V8.59992C10.6668 6.26658 9.7335 5.33325 7.40016 5.33325H5.3335V4.59992C5.3335 2.26659 6.26683 1.33325 8.60016 1.33325H11.4002C13.7335 1.33325 14.6668 2.26659 14.6668 4.59992Z" stroke="#6F778D" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                </CopyToClipboard>
            </div>

            <a href={post.post.link} className="modal-external-link" target="_blank">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M8.6665 7.33337L14.1332 1.8667" stroke="#0075FF" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M14.6668 4.53325V1.33325H11.4668" stroke="#0075FF" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M7.3335 1.33325H6.00016C2.66683 1.33325 1.3335 2.66659 1.3335 5.99992V9.99992C1.3335 13.3333 2.66683 14.6666 6.00016 14.6666H10.0002C13.3335 14.6666 14.6668 13.3333 14.6668 9.99992V8.66658" stroke="#0075FF" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>

                Open Facebook
            </a>

            <div className="block">
                <div style={{
                    opacity: button ? 0.7 : 1,
                    cursor: button ? 'no-drop' : 'pointer'
                }} className="modal-button blue" onClick={e => {
                    if(button)
                        return;

                    dispatch(updateModal('facebook_post', {
                        stage: "verify",
                        verify: {
                            post_id: post.post.id
                        }
                    }));
                }}>
                    I’ve Shared It — Continue
                </div>
            </div>
        </>
    )
} 